import { FC, PropsWithChildren } from 'react';

import { twMerge } from 'tailwind-merge';

import { CloseIcon } from '../../../assets';
import { useViewportStore } from '../../../lib';
import { Button } from '../../button';
import { DialogClose } from '../../dialog';
import { DrawerClose } from '../../drawer';
import { IModalTemplateButton, TModalRightButton } from './types';

const RightButton: FC<PropsWithChildren<IModalTemplateButton>> = ({
  onClick,
  className,
  children,
}) => (
  <Button
    variant="base-300"
    size="icon"
    className={twMerge(
      'absolute right-1 top-1 h-[56px] w-[56px] rounded-full',
      className,
    )}
    onClick={onClick}
  >
    {children}
  </Button>
);

export const ModalRightButton: FC<TModalRightButton> = ({
  Component,
  className,
  isHasCloseBtn,
  isIcon,
  onClick,
  onClose = () => {},
}) => {
  const isMobile = useViewportStore((state) => state.isMobile);
  if (!isIcon && Component) return Component;
  if (isHasCloseBtn) {
    if (isMobile)
      return (
        <DrawerClose asChild className="!z-50">
          <RightButton className={className} onClick={onClose}>
            <CloseIcon className="!size-6" />
          </RightButton>
        </DrawerClose>
      );
    return (
      <DialogClose asChild className="!z-50">
        <RightButton className={className} onClick={onClose}>
          <CloseIcon className="!size-6" />
        </RightButton>
      </DialogClose>
    );
  }
  return (
    <RightButton className={className} onClick={onClick}>
      {(isIcon && Component) || <CloseIcon className="!size-6" />}
    </RightButton>
  );
};
